import React from 'react';
import {
  HomeOutlined,
  BusinessOutlined,
  InsertChartOutlined,
  AutoAwesomeMotionOutlined,
  DashboardOutlined,
  InsightsOutlined,
} from '@mui/icons-material';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import arcLogo from '@/assets/images/arcweb.svg';
import styles from '@/components/templates/DrawerTemplate/drawertemplate.module.css';

interface DrawerItem {
  text: string;
  icon?: string;
  path: string;
  onClick?: () => void;
}

interface DrawerTemplateProps {
  title: string;
  items: DrawerItem[];
  children: React.ReactNode;
}

const DrawerTemplate: React.FC<DrawerTemplateProps> = ({ items, children }) => {
  const location = useLocation();
  const iconMap = {
    home: <HomeOutlined sx={{ fontSize: 24 }} />,
    dashboard: <DashboardOutlined sx={{ fontSize: 22 }} />,
    company: <BusinessOutlined sx={{ fontSize: 22 }} />,
    analysis: <InsertChartOutlined sx={{ fontSize: 22 }} />,
    difference: <AutoAwesomeMotionOutlined sx={{ fontSize: 22 }} />,
    forecast: <InsightsOutlined sx={{ fontSize: 22 }} />,
  };

  const getIcon = (iconName?: string) => {
    if (!iconName) return null;
    return iconMap[iconName as keyof typeof iconMap] || null;
  };

  return (
    <Box className={styles.root}>
      <Drawer
        className={styles.drawer}
        variant="permanent"
        anchor="left"
        classes={{
          paper: styles.drawerPaper,
        }}
      >
        <div className={styles.logo}>
          <img src={arcLogo} alt="data-image" />
        </div>
        <List>
          {items.map(item => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton
                onClick={item.onClick}
                className={location.pathname === item.path ? styles.activeItem : undefined}
              >
                {item.icon && (
                  <ListItemIcon sx={{ minWidth: '40px' }}>{getIcon(item.icon)}</ListItemIcon>
                )}
                <ListItemText className={styles.drawerText} primary={item.text} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box component="main" className={styles.content}>
        {children}
      </Box>
    </Box>
  );
};

export default DrawerTemplate;
